import { Module } from 'vuex'
import * as Sentry from '@sentry/vue'

interface State {
  currentLocale?: string;
}

const store: Module<State, any> = {
  namespaced: true,
  state: {
    currentLocale: undefined,
  },
  getters: {
    currentLocale: (state: State): string | undefined => state.currentLocale,
  },
  actions: {
    set({ commit }, { locale }) {
      document.documentElement.lang = locale
      commit('SET_CURRENT_LOCALE', locale)
    },
  },
  mutations: {
    SET_CURRENT_LOCALE(state, data) {
      state.currentLocale = data
      const $i18n = this.$i18n as any
      $i18n.locale = data
      Sentry.setTag('locale', data)
    },
  },
}

export default store
